// extracted by mini-css-extract-plugin
module.exports = {"button":"idt-arpreviewbutton_button__2kdk-"};